export enum PutOrderItemRequestType {
  ADD = 'Add',
  REMOVE = 'Remove',
  UPDATE_QUANTITY = 'UpdateQuantity'  
} 